import { supportPagesCardsStyles } from './supportPagesCardsStyles';
import { itSupportCardsData, maintenanceSupportCardsData } from './supportPagesCardsDatas';

const sameSupportCooperationData = {
  title: 'Многоуровневая структура технической поддержки ASTON',
  titleProps: { maxW: { laptop: '1000px' } },
  subtitle: 'Мы используем гибкий подход для работы с меняющимися потребностями бизнеса',
  cardsStyles: supportPagesCardsStyles,
};

export const itSupportCooperationData = {
  ...sameSupportCooperationData,
  cardsData: itSupportCardsData,
};

export const maintenanceSupportCooperationData = {
  ...sameSupportCooperationData,
  cardsData: maintenanceSupportCardsData,
  metricName: 'it-support_goto_form',
};
